export const permissionsKeys = {
  page: 'micro-sites.pqrsd.page-block',
  pageBlockFind: 'micro-sites.pqrsd.page-block.find',
  pageBlockCreateDefault: 'micro-sites.pqrsd.page-block.createDefault',
  pageBlockUpdate: 'micro-sites.pqrsd.page-block.update',
  pageBlockPreview: 'micro-sites.pqrsd.page-block.preview',
  pageBlockUpdateInactivate: 'micro-sites.pqrsd.inactivate.page-block.update',
  pageBlockUpdateActive: 'micro-sites.pqrsd.active.page-block.update',
  pageBlockRemove: 'micro-sites.pqrsd.page-block.remove',
};
